import React, { ReactNode } from "react";
import "./PiSettingsTile.css";

type PiSettingsTileProps = {
  children: ReactNode;
  title: string;
  icon?: React.ElementType | null;
  variant?: "default" | "divided";
  className?: string;
  headerClassName?: string;
  iconClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
};

export default function PiSettingsTile(props: PiSettingsTileProps) {
  const {
    children,
    title,
    icon: Icon,
    variant = "default",
    className = "",
    headerClassName = "",
    iconClassName = "",
    titleClassName = "",
    contentClassName = "",
  } = props;

  const rootClassName =
    `pisettingstile pisettingstile--${variant} ${className}`.trim();

  return (
    <div className={rootClassName}>
      <div className={`pisettingstile-header ${headerClassName}`.trim()}>
        <div className={`pisettingstile-icon ${iconClassName}`.trim()}>
          {Icon && <Icon />}
        </div>
        <div className={`pisettingstile-title ${titleClassName}`.trim()}>
          {title}
        </div>
      </div>
      <div className={`pisettingstile-content ${contentClassName}`.trim()}>
        {children}
      </div>
    </div>
  );
}
